// extracted by mini-css-extract-plugin
module.exports = {"paypal_modal__body":"modal-body-module--paypal_modal__body--9eqg3"};